import * as React from 'react';
import {FC, PropsWithChildren} from 'react';

export interface BadgeProps {

}

export const Badge: FC<PropsWithChildren> = (props) =>
    <span
        className="ml-4 inline-flex items-center justify-center px-2 py-1 mr-2 text-xs font-bold leading-none text-m-gray-2 bg-m-green rounded-full">
    {props.children}
</span>;

